<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M413.3 911H207.5c-8.8 0-17.2-1.2-25.2-3.6-7.1-2.1-13.9-5-20.2-8.7L368.5 790c17.1-7.7 28.2-24.8 28.2-43.9V277.7c0-18.8-11.1-36.2-28.2-43.9L155.9 129.2c2.3-1.6 4.7-3.1 7.1-4.5 13.2-7.5 28.3-11.7 44.5-11.7h348.3c49.9 0 90.5 40.6 90.5 90.5V319c0 16 13 29 29 29s29-13 29-29V203.5c0-27.6-7.6-53.4-20.7-75.6C657.7 84.3 610.1 55 555.8 55H207.5C125.6 55 59 121.6 59 203.5v617C59 902.4 125.6 969 207.5 969h205.8c16 0 29-13 29-29s-13-29-29-29z" />
        <path d="M762.4 647.3c50.9-20.9 86.6-71.1 86.1-129.6-.6-76.7-63.3-138.5-140-137.9S570 443 570.6 519.8c.5 58.4 36.9 108.1 88 128.4-259.8-37.9-192 253.8-192 253.8 39.7 42.9 178.4 50 234.1 51.1.3.2.5.3.5.3s4.3 0 11.5-.2c7.3.1 11.5 0 11.5 0s.2-.2.5-.4c55.7-2 194.2-11.1 233.3-54.6.1 0 63.6-292.7-195.6-250.9z" />
      </g>
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
